import React, { useEffect, useState, useTransition } from 'react';
import { AppInterface, Message_Internal_Dialog, MessageSenderDialog, RecordsPagination, ThemedButton, ThemedDropdownMenu } from "../../index";
import { GenRouteUrls, Keys, ModuleFieldsData, Modules, ReqUrls } from "../../config/AppConfig";
import { useTheme } from "../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    getArrLen,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    limitStringWords,
    setTabTitle,
    shuffleList,
    sortJsonListAdvance
} from "../../../common/fusion-ui/utils/ReactUtils";
import { formatDateValue, getAllocatedModuleName, getUserSessionField, printError, printLog, sendRequest } from "../../utils/AppUtils";
import { useToast } from "../../../common/fusion-ui/provider/ToastProvider";
import { Anchor, Avatar, CircleLoading, Flexbox, GridBox, Label, LoadingSection, PolyStateToggle, Section } from "../../../common/fusion-ui"
import { CssVariant, DefStrNA, Messages } from 'common/fusion-ui/config/FusionConfig';
import { useConfig } from "../../context/ConfigProvider";
import useScreenSize from "../../../common/fusion-ui/hook/useScreenSize";
import { AnimationType, FramerAnimator } from "../../../common/fusion-ui/animation/FramerAnimator";

const MessagePage = React.memo(({
    fromSearchPage = false,
    recordList,
    showControls = true,
}) => {
    const TAG = "MessagePage";

    const moduleName = Modules.Messages;
    const mf = ModuleFieldsData[moduleName];

    const animator = new FramerAnimator();

    const PAGINATION_RECORD_LIMITS = [8, 12, 16, 20];
    const DEF_PGNTN_RECORD_LIMIT = PAGINATION_RECORD_LIMITS[0];
    const DEF_PGNTN_START_INDEX = 1;
    const MessageTypes = {
        all: { id: 0, label: 'All', variant: 'info', variantAlt: 'primary' },
        received: { id: 1, label: 'Received', variant: 'success', variantAlt: 'primaryAlt' },
        sent: { id: 2, label: 'Sent', variant: 'primary', variantAlt: 'primaryBlue' },
    };
    const SORT_BY_PARAMS = {
        from: {
            name: mf.fromName.title,
            sortKey: mf.fromName.column,
        },
        subject: {
            name: mf.subject.title,
            sortKey: mf.subject.column,
        },
        date: {
            name: mf.insertDate.title,
            sortKey: mf.insertDate.column,
        },
    };

    const theme = useTheme();
    const { showToast, changeToastVariant } = useToast();
    const { isConfigTrue, updateConfig } = useConfig();
    const { isScreenUpSm, isScreenXs, isScreenSm } = useScreenSize();

    const Fields = {
        recordList: `${TAG}_recordList`,

        isDataLoading: 'isDataLoading',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFound: 'isDataFound',
        isDataFetched: 'isDataFetched',

        pagination_currPageNum: 'pagination_currPageNum',
        pagination_currPageLimit: 'pagination_currPageLimit',

        currMessageTypeId: 'currMessageTypeId',
        sortBySelectedOption: 'sortBySelectedOption',
        sortBySelectedOptionSortKey: 'sortBySelectedOptionSortKey',
        isSortByOrderAsc: 'isSortByOrderAsc',

        currRecordId: 'currRecordId',
        openMessageDetailsDialog: 'openMessageDetailsDialog',

        openSendMsgDialog: 'openSendMsgDialog',
        messageDialog_replyMode: 'messageDialog_replyMode',
        messageDialog_replyModeData: 'messageDialog_replyModeData',
        recordMail_submitBtn_AsLoading: 'recordMail_submitBtn_AsLoading',
        recordMail_submitBtn_disabled: 'recordMail_submitBtn_disabled',
        messageDialog_clearData: 'messageDialog_clearData',

        recordMail_replyBtn_Disable: 'recordMail_replyBtn_Disable',
        recordMail_replyBtn_AsLoading: 'recordMail_replyBtn_AsLoading',
    };
    const [fieldsData, setFieldsData] = useState({
        [Fields.isDataLoading]: true,
    });
    const [messageTypeChangePending, startMessageTypeChangeTransition] = useTransition();
    const [sortListPending, startSortListTransition] = useTransition();

    useEffect(() => {
        if (!isBoolTrue(fromSearchPage)) {
            setTabTitle(getAllocatedModuleName(moduleName));
            updateConfig(Keys.config_ShowTabBar, true);
            updateConfig(Keys.config_TabBarTab, -1);
            updateConfig(Keys.config_navbarCurrPage, moduleName);
            updateConfig(Keys.tracker_currPageModule, moduleName);
            updateConfig(Keys.tracker_currPageTag, TAG);
        }
        if (!checkNullStr(getField(Fields.pagination_currPageNum))) {
            updateField(Fields.pagination_currPageNum, DEF_PGNTN_START_INDEX);
            updateField(Fields.pagination_currPageLimit, DEF_PGNTN_RECORD_LIMIT);
            updateField(Fields.isSortByOrderAsc, true);
            updateField(Fields.currMessageTypeId, MessageTypes.all.id);
            updateField(Fields.sortBySelectedOption, SORT_BY_PARAMS.from.name);
            updateField(Fields.sortBySelectedOptionSortKey, SORT_BY_PARAMS.from.sortKey);
        }
    }, [fromSearchPage]);

    useEffect(() => {
        if (isBoolTrue(fromSearchPage)) {
            if (!isFieldTrue(Fields.isDataFetched)) {
                updateField(Fields.isDataFetched, true);
                const success = checkNullArr(recordList);
                // log('useEffect.recordList:', recordList, 'found:', checkNullArr(recordList));
                updateField(Fields.isDataLoading, false);
                updateField(Fields.dataLoadingMsg, success ? '' : Messages.noDataFound);
                updateField(Fields.isDataFound, success);
                createTimeout(() => {
                    updateField(Fields.recordList, recordList);
                }, 100);
            }
        } else {
            fetchPageData();
        }
    }, [fromSearchPage, recordList]);


    useEffect(() => {
        if (!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataLoading)) {
            // handleRecordVisLimitChange(getField(Fields.pagination_currPageLimit, DEF_PGNTN_RECORD_LIMIT));
        }
    }, [messageTypeChangePending]);

    useEffect(() => {
        if (!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataLoading)) {
            // handleSortByChange(getField(Fields.sortBySelectedOption, SORT_BY_PARAMS.from.name), getField(Fields.sortBySelectedOptionSortKey, SORT_BY_PARAMS.from.sortKey), [], false);
        }
    }, [startMessageTypeChangeTransition]);

    return (<>
        {isBoolTrue(fromSearchPage) ? createRecordListPanel() : createPage()}
        {createSendMessageDialog()}
        {createMessageDetailsDialog()}
    </>);

    function createPage() {
        return <AppInterface label={moduleName}>
            <div className={`m-0 p-0 w-100`}>

                {<LoadingSection
                    labelClassName={'m-2 w-100 fs-normal'}
                    heightClass={75}
                    color={theme.text70}
                    success={isFieldTrue(Fields.isDataFound)}
                    loading={isFieldTrue(Fields.isDataLoading)}
                    msg={getField(Fields.dataLoadingMsg)}
                />}

                {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) &&
                    <div className={'m-0 p-0 w-100 h-100 position-relative'}>
                        {createRecordListPanel()}
                    </div>}
            </div>
        </AppInterface>
    }

    function createRecordListPanel() {
        return <div>

            {/*header*/}
            {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) &&
                <div className={`m-0 p-0 mt-1`}>
                    {animator.setAnimationType(AnimationType.SLIDE_DOWN).render(
                        <Flexbox className={''}
                            justifyAt={'between'} alignAt={'center'}
                            justifyAtSm={'start'} alignAtSm={'start'}
                            wrapSm={'wrap'} directionSm={'column'}>
                            {/*create-msg btn*/}
                            {!isBoolTrue(fromSearchPage) && <ThemedButton
                                className={'w-auto fs-sm text-nowrap fw-semi-bold'}
                                outlined={true}
                                sleek={true}
                                my={1}
                                disabled={isFieldTrue(Fields.isDataLoading)}
                                text={`Create a Message`}
                                variant={theme.primaryBlue}
                                onClick={() => updateField(Fields.openSendMsgDialog, true)}
                            />}

                            {/*end*/}
                            <Flexbox className={''}
                                justifyAt={'start'} alignAt={'center'}
                                wrapSm={'wrap'} alignAtSm={'start'} 
                                // Update by Vandit Tewari on (8/11/24) passed 2 parameter to make it responsive in phones by making in 2 diffrent lines
                                directionSm = "column" gap = "5px"
                            >
                                {/*message-type toggle*/}
                                <PolyStateToggle
                                    className={'mx-1'}
                                    variant={'success'}
                                    bgVariant={'transparent'}
                                    rippleVariant={'light'}
                                    reverseVariant={'white'}
                                    itemClassName={''}
                                    itemIconClassName={''}
                                    buttonHeight={'26px'}
                                    fsVariant={'sm'}
                                    defOption={getField(Fields.currMessageTypeId)}
                                    onSwitch={(text, index, item) => {
                                        // log('onSwitch.item:', item);
                                        updateField(Fields.currMessageTypeId, index);
                                        handleMessageTypeChange(getJsonValue(item, 'id'));
                                    }}>{Object.values(MessageTypes).map((item) => {
                                        return { id: item.id, text: item.label, variant: item.variant }
                                    })}</PolyStateToggle>

                                {/*sort-by dropdown*/}
                                <Flexbox className={''} justifyAt={'start'} alignAt={'center'}
                                    disabled={!checkNullArr(getRecordList()) || isFieldTrue(Fields.isDataLoading)}>
                                    <ThemedDropdownMenu
                                        className={''}
                                        buttonClassName={'border-none fw-bold ms-2 text-nowrap'}
                                        // variant={getJsonValue(Object.values(MessageTypes).find(item => item.id == getField(Fields.currMessageTypeId)), 'variantAlt', 'primaryBlue')}
                                        variant={'primaryBlue'}
                                        textWrap={'nowrap'}
                                        buttonHeight={'26px'}
                                        outlined={false}
                                        textPrefix={<span className={'fw-normal'}>Sort by:</span>}
                                        textPostfix={<i className={`${!isFieldTrue(Fields.isSortByOrderAsc) ? 'bi bi-sort-up-alt' : 'bi bi-sort-down'}`} />}
                                        defOption={getField(Fields.sortBySelectedOption)}
                                        onItemClick={(name, index, item) => handleSortByChange(name, getJsonValue(item, 'sortKey'))}>
                                        {Object.values(SORT_BY_PARAMS).map((item) => {
                                            return {
                                                ...item,
                                                // iconRight: isFieldTrue(Fields.isSortByOrderAsc) ? item.iconRight : item.iconRightReverse
                                            }
                                        })}
                                    </ThemedDropdownMenu>

                                    {/*loader*/}
                                    {(sortListPending) && <CircleLoading widthClass={'x'} wrapperClassName={'ms-1'} size={'14px'} borderWidth={'2px'} />}
                                </Flexbox>
                            </Flexbox>
                        </Flexbox>
                    )}
                </div>}

            {/* record-list */}
            {<div className={'w-100'}>
                {/*{animator.setAnimationType(AnimationType.SLIDE_UP).renderChildren(*/}
                <GridBox className={'px-2'} sm={12} md={6} gap={1} justifyAt={'start'}>
                    {getRecordListToRender().map((item, index) => {
                        const recordId = getJsonValue(item, mf.recordId.column);
                        return (checkNullJson(item)) &&
                            animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(100 * index).render(
                                <Section key={index + getJsonValue(item, mf.fromName.column)}
                                    className={'m-0 p-1 h-100 app-section hover'}
                                    borderless={false}
                                    roundedVariant={4}
                                    borderColor={theme.text20}>
                                    <div className={'px-2 py-0 row al-center'} key={index}>
                                        {/* left - img & texts */}
                                        <div className={'m-0 p-1 col-sm-9 col-md-9'}>
                                            <Flexbox className={''} key={index}
                                                justifyAt={'start'}
                                                alignAt={'center'}>
                                                {/* img */}
                                                <div className={'m-0 p-0 ps-1'}>
                                                    <Avatar
                                                        wrapperClassName={'m-0 p-0 ms-1'}
                                                        imgClassName={'rounded-3'}
                                                        size={'70px'}
                                                        circular={false}
                                                        bordered={false}
                                                        showFullPreviewDialog={true}
                                                        showInitials={checkNullStr(getJsonValue(item, mf.fromName.column))}
                                                        nameForInitials={getJsonValue(item, mf.fromName.column)}
                                                    >
                                                        {getJsonValue(item, mf.fromImage.column)}
                                                    </Avatar>
                                                </div>
                                                <div className={'p-0 m-0 ps-2 w-100'}>
                                                    {/*fromName*/}
                                                    <Flexbox className={'m-0 p-0 w-100'} justifyAt={'between'} alignAt={'start'}>
                                                        <Flexbox className={'w-auto'}>
                                                            <Label className={'m-0 p-0 fw-semi-bold'} color={theme.text}>
                                                                {mf.fromName.title}: &nbsp;
                                                            </Label>
                                                            <Anchor
                                                                wrapperClassName={'w-auto'}
                                                                className={'fw-semi-bold m-0 p-0 text-wrap'}
                                                                simple={false}
                                                                href={`${GenRouteUrls.msg_internalPage}${recordId}`}
                                                                onClick={(e) => {
                                                                    if (!isScreenUpSm) {
                                                                        e.preventDefault();
                                                                        if (e.ctrlKey) {
                                                                            window.open(`${GenRouteUrls.msg_internalPage}${recordId}`, '_blank');
                                                                        } else {
                                                                            updateField(Fields.currRecordId, recordId);
                                                                            updateField(Fields.openMessageDetailsDialog, true);
                                                                        }
                                                                    }
                                                                }}>
                                                                {getJsonValue(item, mf.fromName.column, DefStrNA)}
                                                            </Anchor>
                                                            {/*<span className={'fw-semi-bold'} style={{color: theme.text}}>{mf.fromName.title}: </span>*/}
                                                            {/*<span*/}
                                                            {/*    className={'m-0 p-0 fw-bold text-nowrap footer-linkx'}>{" "}{getJsonValue(item, mf.fromName.column, DefStrNA)}</span>*/}
                                                        </Flexbox>

                                                        {/*type label*/}
                                                        <div className={'mt-1 pt-1x'}>
                                                            <Label className={'fs-sm m-0 p-0 px-2 d-flex flex-nowrap al-center jc-center fw-semi-bold rounded-2'}
                                                                height={'18px'}
                                                                color={!isRecordSentType(item) ? theme.primaryAltDark : theme.primaryBlueDark}
                                                                bgColor={!isRecordSentType(item) ? theme.primaryAltDark30 : theme.primaryBlue30}>
                                                                {!isRecordSentType(item) ? 'Received' : 'Sent'}
                                                            </Label>
                                                        </div>
                                                    </Flexbox>

                                                    {/*subject*/}
                                                    <div className={'mt-n1'}>
                                                        <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                                            <span className={'fw-semi-bold'}>{mf.subject.title}: </span>
                                                            <span>{" "}{limitStringWords(getJsonValue(item, mf.subject.column, DefStrNA), 35, '', '...')}</span>
                                                        </Label>
                                                    </div>

                                                    {/*date*/}
                                                    <div className={'mt-n1'}>
                                                        <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                                            <span className={'fw-semi-bold'}>{mf.insertDate.title}: </span>
                                                            <span
                                                                className={'text-nowrap'}>{" "}{formatDateValue(getJsonValue(item, mf.insertDate.column), DefStrNA)}</span>
                                                        </Label>
                                                    </div>
                                                </div>
                                            </Flexbox>
                                        </div>

                                        {/* right -  controls */}
                                        {/* Updated by Vandit Tewari (29/10/24) - added an style with ternary operator to show its copy div according to scrren size to make it responsive */}
                                        <div className={'m-0 p-1 col-sm-3 col-md-3 '} style={{ display: window.innerWidth < 950 ? 'none' : 'block' }}>
                                            <div className={'m-0 p-1 px-2 d-flex fd-column fd-row-sm flex-nowrap-sm jc-center-sm al-center-sm'}>
                                                {/*view btn*/}
                                                {<ThemedButton
                                                    width={'100%'}
                                                    className={'px-2 fs-sm w-auto text-nowrap fw-semi-bold'}
                                                    outlined={true}
                                                    m={1}
                                                    height={'24px'}
                                                    icon={'bi bi-eye'}
                                                    text={`View`}
                                                    variant={theme.primaryBlue}
                                                    href={`${GenRouteUrls.msg_internalPage}${recordId}`}
                                                    onClick={(e) => {
                                                        if (!isScreenUpSm) {
                                                            e.preventDefault();
                                                            if (e.ctrlKey) {
                                                                window.open(`${GenRouteUrls.msg_internalPage}${recordId}`, '_blank');
                                                            } else {
                                                                updateField(Fields.currRecordId, recordId);
                                                                updateField(Fields.openMessageDetailsDialog, true);
                                                            }
                                                        }
                                                    }}
                                                />}

                                                {/*Reply btn*/}
                                                {(isBoolTrue(showControls) && !isRecordSentType(item)) && <ThemedButton
                                                    className={'px-2 fs-sm w-auto text-nowrap fw-semi-bold'}
                                                    outlined={true}
                                                    m={1}
                                                    height={'24px'}
                                                    icon={'bi bi-reply'}
                                                    text={`Reply`}
                                                    variant={theme.primaryBlue}
                                                    asLoading={recordId == getField(Fields.currRecordId) && isFieldTrue(Fields.recordMail_replyBtn_AsLoading)}
                                                    disabled={recordId == getField(Fields.currRecordId) && isFieldTrue(Fields.recordMail_replyBtn_Disable)}
                                                    onClick={() => {
                                                        updateField(Fields.currRecordId, recordId);
                                                        fetchRecordReplyModeData(recordId, item);
                                                    }}
                                                />}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Added by Vandit Tewari (29/10/24) - make an copy of right controls from top and pasted here code is same just some change in classes used done this because in tablets the view button is overlaping with left data of card */}
                                    {/* right -  controls */}
                                    {/* Updated by Vandit Tewari (29/10/24) - added an style with ternary operator to show its copy div according to scrren size to make it responsive */}
                                    <div className={'m-0 p-1 col-sm-4 col-md-4 '} style={{ display: window.innerWidth < 950 ? 'block' : 'none' }}>
                                        <div className={'m-0 p-1 px-2 d-flex fd-row fd-row-sm flex-nowrap-sm jc-center-sm al-center-sm'}>
                                            {/*view btn*/}
                                            {<ThemedButton
                                                width={'100%'}
                                                className={'px-2 fs-sm w-auto text-nowrap fw-semi-bold'}
                                                outlined={true}
                                                m={1}
                                                height={'24px'}
                                                icon={'bi bi-eye'}
                                                text={`View`}
                                                variant={theme.primaryBlue}
                                                href={`${GenRouteUrls.msg_internalPage}${recordId}`}
                                                onClick={(e) => {
                                                    if (!isScreenUpSm) {
                                                        e.preventDefault();
                                                        if (e.ctrlKey) {
                                                            window.open(`${GenRouteUrls.msg_internalPage}${recordId}`, '_blank');
                                                        } else {
                                                            updateField(Fields.currRecordId, recordId);
                                                            updateField(Fields.openMessageDetailsDialog, true);
                                                        }
                                                    }
                                                }}
                                            />}

                                            {/*Reply btn*/}
                                            {(isBoolTrue(showControls) && !isRecordSentType(item)) && <ThemedButton
                                                className={'px-2 fs-sm w-auto text-nowrap fw-semi-bold'}
                                                outlined={true}
                                                m={1}
                                                height={'24px'}
                                                icon={'bi bi-reply'}
                                                text={`Reply`}
                                                variant={theme.primaryBlue}
                                                asLoading={recordId == getField(Fields.currRecordId) && isFieldTrue(Fields.recordMail_replyBtn_AsLoading)}
                                                disabled={recordId == getField(Fields.currRecordId) && isFieldTrue(Fields.recordMail_replyBtn_Disable)}
                                                onClick={() => {
                                                    updateField(Fields.currRecordId, recordId);
                                                    fetchRecordReplyModeData(recordId, item);
                                                }}
                                            />}
                                        </div>
                                    </div>
                                </Section>,
                                { className: 'h-100' }
                            )
                    })}
                </GridBox>
                {/*)}*/}
            </div>}

            {/* pagination */}
            <RecordsPagination
                id={TAG}
                show={checkNullArr(getRecordList(true))}
                totalRecords={getArrLen(getRecordList(true))}
                totalRecordsToRender={getArrLen(getRecordListToRender())}
                recordLimits={PAGINATION_RECORD_LIMITS}
                currPage={getField(Fields.pagination_currPageNum)}
                currPageRecordLimit={getField(Fields.pagination_currPageLimit)}
                onPageChange={(e, newPageIndex) => {
                    // log('RecordsPagination.onLimitChange.newPageIndex:', newPageIndex);
                    updateField(Fields.pagination_currPageNum, newPageIndex);
                }}
                onLimitChange={(newLimit, newPageIndex) => {
                    // log('RecordsPagination.onLimitChange.newLimit:', newLimit, 'newPageIndex:', newPageIndex);
                    updateField(Fields.pagination_currPageLimit, newLimit);
                    updateField(Fields.pagination_currPageNum, newPageIndex);
                }}
            />
        </div>
    }

    function createMessageDetailsDialog() {
        return <Message_Internal_Dialog
            recordId={getField(Fields.currRecordId)}
            open={isFieldTrue(Fields.openMessageDetailsDialog)}
            asDrawer={true}
            onHide={() => {
                updateField(Fields.openMessageDetailsDialog, false);
                updateField(Fields.currRecordId, null);
            }}
        />
    }

    function createSendMessageDialog() {
        return <MessageSenderDialog
            open={isFieldTrue(Fields.openSendMsgDialog)}
            recordId={getField(Fields.currRecordId)}
            clearData={isFieldTrue(Fields.messageDialog_clearData)}
            replyMode={isFieldTrue(Fields.messageDialog_replyMode)}
            replyData={getField(Fields.messageDialog_replyModeData, {})}
            recipientNameAsEmail={true}
            asDrawer={true}
            disableSubmit={isFieldTrue(Fields.recordMail_submitBtn_disabled)}
            loadingSubmit={isFieldTrue(Fields.recordMail_submitBtn_AsLoading)}
            onSubmit={handleMsgDialogSubmit}
            onHide={handleClose}
            onCancel={handleClose}
        />

        function handleClose() {
            updateField(Fields.openSendMsgDialog, false);
            updateField(Fields.currRecordId, null);
            updateField(Fields.messageDialog_replyMode, false);
            updateField(Fields.recordMail_submitBtn_disabled, false);
            updateField(Fields.recordMail_submitBtn_AsLoading, false);
            updateField(Fields.messageDialog_replyModeData, {});
            updateField(Fields.messageDialog_clearData, false);
        }
    }

    async function fetchPageData(checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            updateField(Fields.isDataFetched, true);
            try {
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.recordList, []);
                updateField(Fields.currRecordId, null);

                // updateField(Fields.recordList, MessagePageConfig);
                // updateField(Fields.isDataFound, true);
                // updateField(Fields.isDataLoading, false);

                //send-request
                const REQUEST_OPTIONS = {};
                sendRequest({
                    reqUrl: ReqUrls.msg__mainPage_fetch_recordList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const recordList = getJsonValueFromNestedKeys(fetchedData, ['data', 'recordList'], []);

                        const success = checkNullArr(recordList);
                        updateField(Fields.isDataFound, success);
                        log(fun, 'fetchedData.recordList:', recordList, 'success:', success);
                        if (success) {
                            // toast(Messages.fetchSuccess, CssVariant.success);success)
                            updateField(Fields.recordList, recordList);
                        } else {
                            updateField(Fields.dataLoadingMsg, Messages.noDataFound);
                            toast(Messages.noDataFound, CssVariant.danger);
                        }
                        updateField(Fields.isDataLoading, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        updateField(Fields.isDataLoading, false);
                        updateField(Fields.isDataFound, false);
                        updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                updateField(Fields.isDataLoading, false);
                updateField(Fields.isDataFound, false);
                updateField(Fields.dataLoadingMsg, Messages.fetchError);
            }
        }
    }

    async function fetchRecordReplyModeData(recordId, recordItem) {
        const fun = 'fetchRecordReplyModeData:';
        const fromId = getJsonValue(recordItem, mf.fromId.column);
        log(fun, 'recordId:', recordId, 'fromId:', fromId);
        if (checkNullStr(recordId)) {
            updateField(Fields.messageDialog_replyModeData, {});
            updateField(Fields.recordMail_replyBtn_AsLoading, true);
            updateField(Fields.recordMail_replyBtn_Disable, true);

            //send-request
            const REQUEST_OPTIONS = {
                recordId: recordId,
                fromId: fromId,
                fetchThread: true,
                fetchImages: false,
            };
            try {
                sendRequest({
                    reqUrl: ReqUrls.msg__internalPage_fetchData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const panelData = getJsonValue(fetchedData, 'data', {});
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');

                        if (success) {
                            updateField(Fields.messageDialog_replyModeData, panelData);
                            updateField(Fields.messageDialog_replyMode, true);
                            updateField(Fields.openSendMsgDialog, true);
                        } else {
                            toast(message, CssVariant.danger)
                            toast("Invalid record id!", CssVariant.danger);
                        }

                        updateField(Fields.recordMail_replyBtn_AsLoading, false);
                        updateField(Fields.recordMail_replyBtn_Disable, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        toast("Reply failed, please try again!", CssVariant.danger);
                        updateField(Fields.recordMail_replyBtn_AsLoading, false);
                        updateField(Fields.recordMail_replyBtn_Disable, false);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                toast("Reply failed, please try again!", CssVariant.danger);
                updateField(Fields.recordMail_replyBtn_AsLoading, false);
                updateField(Fields.recordMail_replyBtn_Disable, false);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }

    function handleMsgDialogSubmit(formData, recordId) {
        const fun = 'handleMsgDialogSubmit:';
        // const recordId = getField(Fields.currRecordId);
        log(fun, 'formData:', formData, 'recordId:', recordId);
        if (!isFieldTrue(Fields.messageDialog_replyMode) || (isFieldTrue(Fields.messageDialog_replyMode) && checkNullStr(recordId))) {
            try {
                // const allFieldsChecked = false;
                const allFieldsChecked = true;
                if (allFieldsChecked) {
                    updateField(Fields.recordMail_submitBtn_AsLoading, true);
                    updateField(Fields.recordMail_submitBtn_disabled, true);

                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                        replyMode: isFieldTrue(Fields.messageDialog_replyMode),
                        formData: formData,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.msg__mainPage_createMsg,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            if (success) {
                                toast(message, CssVariant.success);
                                updateField(Fields.openSendMsgDialog, false);
                                if (isFieldTrue(Fields.messageDialog_replyMode)) {
                                    updateField(Fields.currRecordId, null);
                                    updateField(Fields.messageDialog_replyMode, false);
                                    updateField(Fields.messageDialog_clearData, true);
                                } else {
                                    // refreshCurrPage();
                                }
                                fetchPageData(false);
                            } else {
                                toast(message, CssVariant.danger);
                            }
                            updateField(Fields.recordMail_submitBtn_disabled, false);
                            updateField(Fields.recordMail_submitBtn_AsLoading, false);
                        }),
                        onError: ((error) => {
                            toast("Couldn't send message, please try again!");
                            updateField(Fields.recordMail_submitBtn_AsLoading, false);
                            updateField(Fields.recordMail_submitBtn_disabled, false);
                            logErr(fun, error);
                        }),
                    });
                }
            } catch (error) {
                toast("Couldn't send message, please try again!");
                updateField(Fields.recordMail_submitBtn_AsLoading, false);
                updateField(Fields.recordMail_submitBtn_disabled, false);
                logErr(fun, error);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }

    //======================Util Functions start=====================
    function handleMessageTypeChange(messageTypeId) {
        const fun = 'handleMessageTypeChange:';
        try {
            log(fun, 'messageTypeId:', messageTypeId, 'messageTypeId==received.id', messageTypeId == MessageTypes.received.id);
            // log(fun, 'getRecordList:', getRecordList());
            startMessageTypeChangeTransition(() => {
                updateField(Fields.currMessageTypeId, messageTypeId);

                // let recordList = shuffleList([...getRecordList()]);
                // let recordList = [...getRecordList()];
                // recordList = recordList.map((item) => {
                //     return {
                //         ...item,
                //         // [MessageTypes.received.id]: messageTypeId == MessageTypes.received.id,
                //         // [MessageTypes.sent.id]: messageTypeId == MessageTypes.sent.id,
                //     }
                // });
                // sortJsonList(recordList.reverse());
                // recordList=sortJsonListAdvance(recordList, mf.from.column);
                // startMessageTypeChangeTransition(() => {
                // updateField(Fields.recordList, recordList);
                // handleSortByChange(getField(Fields.sortBySelectedOption), getField(Fields.sortBySelectedOptionSortKey), recordList, false);
                // log(fun, 'recordList:', recordList);
            });
        } catch (error) {
            toast('Selection failed, please try again', CssVariant.danger);
            logErr(fun, error);
        }
    }

    function handleSortByChange(name, sortKey, recordList, changeOrder = true) {
        const fun = 'handleSortByChange:';
        try {
            startSortListTransition(() => {
                const sortOption = getField(Fields.sortBySelectedOption);
                const order = isBoolTrue(changeOrder) ? name == sortOption ? !isFieldTrue(Fields.isSortByOrderAsc) : isFieldTrue(Fields.isSortByOrderAsc) : isFieldTrue(Fields.isSortByOrderAsc);

                recordList = [...shuffleList(checkNullArr(recordList) ? recordList : getRecordList())].reverse();

                updateField(Fields.isSortByOrderAsc, order);
                updateField(Fields.sortBySelectedOption, name);
                updateField(Fields.sortBySelectedOptionSortKey, sortKey);

                if (name == SORT_BY_PARAMS.date.name) {
                    recordList.sort((a, b) => {
                        const dateA = new Date(a[sortKey]).getTime();
                        const dateB = new Date(b[sortKey]).getTime();
                        return !order ? dateA - dateB : dateB - dateA;
                    });
                    updateField(Fields.recordList, recordList);
                } else {
                    updateField(Fields.recordList, sortJsonListAdvance(shuffleList(recordList), sortKey, order));
                }
            });
        } catch (error) {
            toast('Sort failed, please try again', CssVariant.danger);
            logErr(fun, error);
        }
    }

    function handleRecordVisLimitChange(newLimit) {
        const fun = 'handleRecordVisLimitChange:';
        try {
            // log(fun, 'newLimit:', newLimit);
            updateField(Fields.pagination_currPageLimit, newLimit);

            // If the current page becomes invalid after changing the record display limit, set it to the last available page
            const newNumPages = Math.ceil(getRecordList().length / newLimit);
            // const newNumPages = Math.ceil(records.length / newLimit);
            if (getField(Fields.pagination_currPageNum) > newNumPages) {
                updateField(Fields.pagination_currPageNum, newNumPages);
            }
        } catch (error) {
            toast('Selection failed, please try again', CssVariant.danger);
            logErr(fun, error);
        }
    }

    function getRecordList(filtered = false) {
        if (checkNullArr(getField(Fields.recordList))) {
            if (isBoolTrue(filtered) && getField(Fields.currMessageTypeId) != MessageTypes.all.id) {
                // if (isBoolTrue(filtered)) {
                return getField(Fields.recordList).filter(item => (getField(Fields.currMessageTypeId) == MessageTypes.sent.id ? isRecordSentType(item) : !isRecordSentType(item)));
            } else {
                return getField(Fields.recordList);
            }
        }
        return [];
    }

    function getRecordListToRender() {
        return getRecordList(true).slice((getField(Fields.pagination_currPageNum) - 1) * getField(Fields.pagination_currPageLimit), getField(Fields.pagination_currPageNum) * getField(Fields.pagination_currPageLimit));
    }

    function isRecordSentType(record = {}) {
        //	If msg.message_from == session.memberId, it's "sent"
        return getJsonValue(record, mf.fromId.column) == getUserSessionField('memberId');
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({ ...prevState, [field]: value }));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }


    //======================Util Functions end=====================
});
export default MessagePage;
